import { render, staticRenderFns } from "./WeekPlan.vue?vue&type=template&id=535dcccc"
import script from "./WeekPlan.vue?vue&type=script&lang=ts"
export * from "./WeekPlan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports